import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from '../../../Shared/Icon/Icon'

class DiscardOfferModal extends React.Component {
  constructor() {
    super()

    this.state = { isDisabledSubmit: false }

    this.discardOffer = this.discardOffer.bind(this)
    this.onModalClose = this.onModalClose.bind(this)
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this)
    this.onSubmitFailure = this.onSubmitFailure.bind(this)
  }

  discardOffer() {
    this.setState({ isDisabledSubmit: true })

    axios.put(`/api/internal/jobs/${this.props.id}/discard_offer`,
      { data: { attributes: { application_id: this.props.applicationId } } })
      .then(this.onSubmitSuccess)
      .catch(this.onSubmitFailure)
  }

  onSubmitSuccess() {
    this.setState({ isDisabledSubmit: false })
    App.events.publish('app:notification:flash:success', 'The Project was cancelled successfully')
    setTimeout(() => window.location.reload(), 3000)
  }

  onSubmitFailure() {
    this.setState({ isDisabledSubmit: false })
    App.events.publish('app:notification:flash:error', 'Something went wrong, please try again')
  }

  onModalClose(e) {
    this.setState({ isDisabledSubmit: false })
    this.props.closeModal(e)
  }

  render() {
    return (
      <Modal
        isOpen
        shouldCloseOnOverlayClick
        onRequestClose={this.onModalClose}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: '',
          afterOpen: 'overlay-modal--container_after-open overlay-modal-container--xs',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="overlay-modal" onClick={(e) => e.stopPropagation()}>
          <button className="btn btn-transparent overlay-modal--close-inner" onClick={this.onModalClose}>
            <Icon type={['fal', 'times']} color="grey-dark" />
          </button>
          <div className="overlay-modal--content overlay-modal--jobs">
            <div className="l-inner-large">
              <h2 className="modal-title">Discard project</h2>
              <p className="modal-description">
                Are you sure you want to continue?
              </p>
              <p className="modal-description">
                This action will discard your Hire Me offer and the project will be cancelled.
              </p>
              <div className="footer u-text-right u-mt10">
                <button className="btn btn-fat btn-outline-default" onClick={this.onModalClose}>Go back</button>
                <button
                  type="submit"
                  className="btn btn-fat btn-primary u-ml10"
                  disabled={this.state.isDisabledSubmit}
                  onClick={this.discardOffer}
                >
                  Discard project
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

DiscardOfferModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  applicationId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  modalIsOpen: PropTypes.bool,
}

DiscardOfferModal.defaultProps = {
  modalIsOpen: false,
}

export default DiscardOfferModal
